import type {JobOutput} from './server/types';
import {proposalOverview,ReportOverview,ReportBody} from './ReportOverview';
export function JobOutputView({output}:{output:JobOutput}) {
  const data=output.data;
  const proposal=data?.completionScope==='proposal_only'||output.type==='agent_proposal';
  const limitations=Array.isArray(data?.limitations)?data.limitations.filter((item):item is string=>typeof item==='string'):[];
  const summary=proposal&&typeof data?.summary==='string'?data.summary:output.title;
  const overview=proposalOverview(output);
  return <article className="job-report">
    <ReportOverview {...overview}/>
    {proposal&&<p className="note">Proposal for review. No publication, message, campaign change or spend has been performed.</p>}
    <section className="report-detail"><h3>Detailed recommendation</h3>{output.body&&<ReportBody body={output.body}/>}</section>
    {!!limitations.length&&<section className="report-detail"><h4>Evidence and limits</h4><ul>{limitations.map((item,index)=><li key={index}>{item}</li>)}</ul></section>}
    {typeof data?.nextDecision==='string'&&<section className="report-detail"><h4>Next decision</h4><p>{data.nextDecision}</p></section>}
    <details className="report-technical"><summary>Full saved summary</summary><p>{summary}</p></details>
    {data&&<details className="report-technical"><summary>Recorded result details</summary><pre className="settings-diff">{JSON.stringify(data,null,2)}</pre></details>}
  </article>;
}
